import ShareModal from '@app/components/ShareModal'
import { IShareContact } from '@app/models/ShareContact'
import { bindFunctions } from '@app/utils/class'
import { List } from 'immutable'
import * as React from 'react'
import {
  actionCreators,
  IShareAttachmentState,
} from '../modules/shareAttachment'

type ShareAttachmentModalProps = IShareAttachmentState & typeof actionCreators

export class ShareAttachmentModal extends React.PureComponent<
  ShareAttachmentModalProps
> {
  constructor(props: ShareAttachmentModalProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    if (!this.props.attachment) {
      return null
    }

    return (
      <ShareModal
        isOpen={true}
        isSaving={this.props.isSaving}
        onCancel={this.props.closeShareAttachmentModal}
        onShare={this._onShare}
        showSubject={true}
        title={`Share ${this.props.attachment.title ||
          this.props.attachment.fileName}`}
      />
    )
  }

  private _onShare(
    contacts: List<IShareContact>,
    comment: string,
    subject: string,
  ) {
    if (this.props.attachment) {
      this.props.shareAttachment(contacts, subject, comment)
    }
  }
}
